var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChattingGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_5891",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.700195,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_5891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.63157 12.0607C9.83777 12.0607 10.0135 11.9881 10.1587 11.8429C10.3039 11.6977 10.3765 11.522 10.3765 11.3158C10.3765 11.1096 10.3039 10.9339 10.1587 10.7887C10.0135 10.6435 9.83777 10.5709 9.63157 10.5709C9.42537 10.5709 9.24966 10.6435 9.10445 10.7887C8.95925 10.9339 8.88664 11.1096 8.88664 11.3158C8.88664 11.522 8.95925 11.6977 9.10445 11.8429C9.24966 11.9881 9.42537 12.0607 9.63157 12.0607ZM13 12.0607C13.2062 12.0607 13.3819 11.9881 13.5271 11.8429C13.6723 11.6977 13.7449 11.522 13.7449 11.3158C13.7449 11.1096 13.6723 10.9339 13.5271 10.7887C13.3819 10.6435 13.2062 10.5709 13 10.5709C12.7938 10.5709 12.6181 10.6435 12.4729 10.7887C12.3277 10.9339 12.2551 11.1096 12.2551 11.3158C12.2551 11.522 12.3277 11.6977 12.4729 11.8429C12.6181 11.9881 12.7938 12.0607 13 12.0607ZM16.3684 12.0607C16.5746 12.0607 16.7503 11.9881 16.8955 11.8429C17.0408 11.6977 17.1134 11.522 17.1134 11.3158C17.1134 11.1096 17.0408 10.9339 16.8955 10.7887C16.7503 10.6435 16.5746 10.5709 16.3684 10.5709C16.1622 10.5709 15.9865 10.6435 15.8413 10.7887C15.6961 10.9339 15.6235 11.1096 15.6235 11.3158C15.6235 11.522 15.6961 11.6977 15.8413 11.8429C15.9865 11.9881 16.1622 12.0607 16.3684 12.0607ZM7.97975 17.6316L6.29394 19.3174C6.05426 19.557 5.77869 19.6113 5.46722 19.4801C5.15574 19.3489 5 19.1128 5 18.7716V6.52228C5 6.0969 5.14737 5.73684 5.44211 5.44211C5.73684 5.14737 6.0969 5 6.52228 5H19.4777C19.9031 5 20.2632 5.14737 20.5579 5.44211C20.8526 5.73684 21 6.0969 21 6.52228V16.1093C21 16.5347 20.8526 16.8947 20.5579 17.1895C20.2632 17.4842 19.9031 17.6316 19.4777 17.6316H7.97975ZM7.44211 16.3684H19.4777C19.5425 16.3684 19.6019 16.3414 19.6559 16.2875C19.7099 16.2335 19.7369 16.1741 19.7369 16.1093V6.52228C19.7369 6.45749 19.7099 6.3981 19.6559 6.34411C19.6019 6.29013 19.5425 6.26314 19.4777 6.26314H6.52228C6.45749 6.26314 6.3981 6.29013 6.34411 6.34411C6.29013 6.3981 6.26314 6.45749 6.26314 6.52228V17.5344L7.44211 16.3684Z",
    fill: "#BABABA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChattingGrey);
export default __webpack_public_path__ + "static/media/chatting_grey.2ec59231cbaec5c1da5ed93abe3f4132.svg";
export { ForwardRef as ReactComponent };